import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y2006 = new LunarYear(
  moment.tz('2006-01-29 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 6, 7, 7, 8, 9, 10, 11, 12],
  [30, 29, 30, 29, 30, 29, 30, 29, 30, 30, 29, 30, 30],
  7,
)

export default Y2006
